import React, { useState } from 'react'
import '../choose-purifier-service/choose-for-purifier.scss'
import NormalInput from '../../common/inputs/NormalInput'
import { useSearchParams } from 'react-router-dom'
import SelectInput from '../../common/inputs/SelectInput'
import { billParties, billReferences, billSources, billStatuses, billTypes } from '../../../assets/constants/finance'

function FilterBill({ setModal }) {
    const [searchParams, setSearchParams] = useSearchParams()

    const [form, setForm] = useState({
        from_date: searchParams.get('from_date') || '',
        end_date: searchParams.get('end_date') || '',
        bill_no: searchParams.get('bill_no') || '',
        bill_type: searchParams.get('bill_type') || '',
        status: searchParams.get('status') || '',
        source: searchParams.get('source') || '',
        taxable: searchParams.get('taxable') || '',
        party_id: searchParams.get('party_id') || '',
        party_type: searchParams.get('party_type') || '',
        ref_id: searchParams.get('ref_id') || '',
        ref_type: searchParams.get('ref_type') || '',
        price_start: searchParams.get('price_start') || '',
        price_end: searchParams.get('price_end') || '',
    })

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        setSearchParams((prev) => {
            const next = new URLSearchParams(prev);
            if (form?.from_date) {
                next.set('from_date', form?.from_date);
            } else {
                next.delete('from_date')
            }

            if (form?.end_date) {
                next.set('end_date', form?.end_date);
            } else {
                next.delete('end_date')
            }

            if (form?.bill_no) {
                next.set('bill_no', form?.bill_no);
            } else {
                next.delete('bill_no')
            }

            if (form?.bill_type) {
                next.set('bill_type', form?.bill_type);
            } else {
                next.delete('bill_type')
            }

            if (form?.status) {
                next.set('status', form?.status);
            } else {
                next.delete('status')
            }
            if (form?.taxable) {
                next.set('taxable', form?.taxable);
            } else {
                next.delete('taxable')
            }
            if (form?.source) {
                next.set('source', form?.source);
            } else {
                next.delete('source')
            }
            if (form?.party_id) {
                next.set('party_id', form?.party_id);
            } else {
                next.delete('party_id')
            }
            if (form?.party_type) {
                next.set('party_type', form?.party_type);
            } else {
                next.delete('party_type')
            }
            if (form?.ref_id) {
                next.set('ref_id', form?.ref_id);
            } else {
                next.delete('ref_id')
            }
            if (form?.ref_type) {
                next.set('ref_type', form?.ref_type);
            } else {
                next.delete('ref_type')
            }
            if (form?.price_start) {
                next.set('price_start', form?.price_start);
            } else {
                next.delete('price_start')
            }
            if (form?.price_end) {
                next.set('price_end', form?.price_end);
            } else {
                next.delete('price_end')
            }
            return next;
        })

        setModal({ status: false })
    }

    return (
        <div className='choose-for-purifier-div'>
            <form action="" onSubmit={handleSubmit}>
                <NormalInput label='From date' type={'date'} name='from_date' value={form?.from_date || ''} onChangeFun={handleChange}
                    min={'2022-10-11'} max={form?.end_date} isRequired={false} />
                <NormalInput label='End date' type={'date'} name='end_date' value={form?.end_date || ''} onChangeFun={handleChange}
                    min={'2022-10-11'} max={new Date().toISOString().split('T')[0]} isRequired={false} />
                <NormalInput label='Bill No' name='bill_no' value={form?.bill_no || ''} onChangeFun={handleChange} isRequired={false}
                    placeholder={'Enter Bill No'} />
                <SelectInput label='Bill Type' name='bill_type' onChangeFun={handleChange} isRequired={false}
                    values={billTypes.map((v) => ({ option: v, value: v, selected: v === searchParams.get('bill_type') }))}
                    firstOption={{ option: 'Choose...', value: '' }} />
                <SelectInput label='Bill Status' name='status' onChangeFun={handleChange} isRequired={false}
                    values={billStatuses.map((v) => ({ option: v, value: v, selected: v === searchParams.get('status') }))}
                    firstOption={{ option: 'Choose...', value: '' }} />
                <SelectInput label='Source' name='source' onChangeFun={handleChange} isRequired={false}
                    values={billSources.map((v) => ({ option: v, value: v, selected: v === searchParams.get('source') }))}
                    firstOption={{ option: 'Choose...', value: '' }} />
                <SelectInput label='Party Type' name='party_type' onChangeFun={handleChange} isRequired={false}
                    values={billParties.map((v) => ({ option: v, value: v, selected: v === searchParams.get('party_type') }))}
                    firstOption={{ option: 'Choose...', value: '' }} />
                <NormalInput label='Party Id' name='party_id' value={form?.party_id || ''} onChangeFun={handleChange} isRequired={false}
                    placeholder={'Enter Party Id'} />
                <SelectInput label='Ref Type' name='ref_type' onChangeFun={handleChange} isRequired={false}
                    values={billReferences.map((v) => ({ option: v, value: v, selected: v === searchParams.get('ref_type') }))}
                    firstOption={{ option: 'Choose...', value: '' }} />
                <NormalInput label='Ref Id' name='ref_id' value={form?.ref_id || ''} onChangeFun={handleChange} isRequired={false}
                    placeholder={'Enter Ref Id'} />

                <div className="button-div">
                    <button type='submit'>Filter</button>
                </div>
            </form>
        </div>
    )
}

export default FilterBill